import React from 'react'

type TrendTypeContextType = 'Live' | 'Segment'

const TrendTypeContext = React.createContext<TrendTypeContextType>('Live')

export default TrendTypeContext
